module.exports = __webpack_public_path__ + "img/kh20.e4ff8334.png";